import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon, Print as PrintIcon } from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { FacilityLabel } from 'src/components/PrintLabel/FacilityLabel'
import { FacilityDialog } from 'src/modules/supply_chain/components/FacilityDialog'
import { AddressField, RelatedLinkedField, ValueField } from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
}

export const FacilityDetailTable = (props: DetailTableProps) => {
  const { obj, refresh } = props
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print, renderPrintComponent } = useAsyncPrint()

  return (
    <>
      {renderPrintComponent()}
      {updateOpen && (
        <FacilityDialog
          open={updateOpen}
          facility={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Facility', onClick: () => setUpdateOpen(true) }],
          },
          {
            Icon: PrintIcon,
            actions: [
              {
                title: 'Print Facility Label',
                onClick: () => print((props) => <FacilityLabel {...props} obj={obj.data} />),
              },
            ],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'market', label: 'Market', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'name', label: 'Name', renderer: ValueField },
          { id: 'address', label: 'Address', renderer: AddressField },
          { id: 'phone', label: 'Phone Number', renderer: ValueField },
        ]}
      />
    </>
  )
}
